export default {
  "APP_NAME": "",
  "BASE_URL": "",
  "REPORTS_BASE_URL": "",
  "ENV": "testing",
  "SUFFIX": "testing",
  "PLATFORM": "web",
  "ENABLE_LOGGING": true
};
